import { render, staticRenderFns } from "./modal-small-card.vue?vue&type=template&id=448057f1"
import script from "./modal-small-card.vue?vue&type=script&lang=js"
export * from "./modal-small-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports